import { css, Global } from '@emotion/react';
import { UnicornTheme } from './lib/theme';
import 'antd/dist/antd.variable.min.css';

type GlobalStylesProps = {
  theme: UnicornTheme;
};

const getStyles = (theme) => css`
  html {
    box-sizing: border-box;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    font-family: 'ZichtbaarRegular', 'Inter', -apple-system, BlinkMacSystemFont,
      'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
      'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #ffffff;
  }

  #root {
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    overflow-x: hidden;
    overflow-y: scroll;
  }

  a,
  a:visited {
    color: ${theme.color.primaryPink};
    font-weight: bold;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  .visually-hidden {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }

  .slider-tooltip {
    background: transparent;
    .ant-tooltip-content {
    }
    &.ant-tooltip-placement-bottom {
      padding-top: 0px !important;
    }
    .ant-tooltip-arrow {
      display: none;
    }
    .ant-tooltip-inner {
      background: transparent;
      box-shadow: none;
      padding: 0px;
      color: black;
    }
  }
`;

const GlobalStyles = ({ theme }: GlobalStylesProps) => (
  <Global styles={getStyles(theme)} />
);

export default GlobalStyles;
